<template lang="html">
    <div id="orders-list">
        <aside>
            <table class="table table-hover table-outlined table-oreders">
                <thead>
                    <th>{{ $t("dashboardModule.thOrderID") }}</th>
                    <th>{{ $t("dashboardModule.thBuyer") }}</th>
                    <th>{{ $t("dashboardModule.thLastActivity") }}</th>
                    <th>{{ $t("dashboardModule.thStatus") }}</th>
                </thead>
                <tbody>
                    <tr v-for="(OrdersList, key) in orderList" :key="key">
                        <td>
                            <router-link
                                v-if="OrdersList.status.reference_status !== 'order_deleted'"
                                :to="{ name: 'MyOrder', params: { id: OrdersList.id } }"
                            >
                                {{ OrdersList.reference }}
                            </router-link>
                            <span v-if="OrdersList.status.reference_status === 'order_deleted'"> {{ OrdersList.reference }} </span>
                        </td>
                        <td>{{ OrdersList.createdBy.firstname }} {{ OrdersList.createdBy.lastname }}</td>
                        <td>{{ OrdersList.modifiedDate }}</td>
                        <td>{{ getTranslate(OrdersList.status.name) }}</td>
                    </tr>
                </tbody>
            </table>
        </aside>
        <slot slot="footer" />
    </div>
</template>

<script lang="js">
import orderService from "@/services/order";

export default  {
    name: 'order-list',
    props: {
        limit: {
            type: Number,
            required: false
        }
    },
    data(){
        return {
            orderList: []
        }
    },
    async created() {
        if (this.limit){
            this.orderList = await orderService.getAllWithLimit(this.limit);
        }else{
            this.orderList = await orderService.getAll();
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
#orders-list {
    width: 100%;
    @extend %primary-text;
    @extend %primary-background;
    .table-oreders {
        border-spacing: 0;
        text-align: left;
        thead th {
            border-bottom: 0;
            border-top: 0;
            font-size: 14px;
            font-family: "oswald-regular", sans-serif;
        }
        tbody {
            tr {
                td {
                    border-top: 0;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #dee2e6;
                    font-size: 14px;
                    font-family: "oswald-regular", sans-serif;
                    a {
                        color: $color2;
                        font-size: 14px;
                        font-family: "oswald-regular", sans-serif;
                        font-weight: bold;
                        text-decoration: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// order-list.vue?0087a694